import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  divider: {
    flex: 1
  },
  fontWeightBold: {
    fontWeight: 500
  },
  styler: {
    marginBottom: Tokens.spacing['$sp-7-5']
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.mode === 'light' ? Palette.FractalUI.light.steel[2] : Palette.FractalUI.dark.steel[2],
    borderRadius: Tokens.spacing['$sp-1'],
    padding: Tokens.spacing['$sp-2'],
    color: theme.palette.text.primary,
    
  },
  iconAlignment: {
    cursor: "pointer",
    marginRight: Tokens.spacing['$sp-2'],
    marginTop: Tokens.spacing['$sp-1']
  }
}));